import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { ApiError } from '@app/shared/models/api-error';
import { inject } from '@angular/core';
import { ToastService } from '@app/core/services/toast.service';
import { SILENT_ERROR_HEADER } from '@utils/http-utils';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const silent = req.headers.has(SILENT_ERROR_HEADER);
  const cleanReq = silent ? req.clone({ headers: req.headers.delete(SILENT_ERROR_HEADER) }) : req;

  return next(cleanReq).pipe(
    catchError((err: HttpErrorResponse) => {
      const apiError = isApiError(err.error) ? err.error : null;
      const normalized = { status: err.status, apiError, raw: err };

      if (!silent) {
        if (err.status === 403) {
          toast.error('Je hebt geen toegang.');
        } else if (normalized.apiError) {
          toast.apiError(apiError);
        }
      }
      return throwError(() => normalized);
    }),
  );
};

function isApiError(body: unknown): body is ApiError {
  return typeof body === 'object' && body !== null && 'error' in body && 'message' in body;
}
